import Error24 from '@carbon/icons-react/es/error/24';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalFuncProps } from 'antd/es/modal';
import merge from 'lodash/merge';
import { LANGUAGE_SELECT } from 'constant/constant';
import { getTranslationCache } from 'utils/translation-loader';
import { defaultModalProps, ModalBase } from './modal';
import * as styles from './modal.module.css';

const defaultMethodProps: ModalFuncProps = {
  className: styles.modal_method,
  icon: (
    <FontAwesomeIcon
      icon={faCircleExclamation}
      fontSize="16px"
      style={{
        marginBottom: '7px',
        marginRight: 'var(--spacing-01)',
      }}
    />
  ),
  zIndex: Number(styles.zIndex),
};

const defaultErrorModalProps: ModalFuncProps = {
  className: styles.modal_method,
  icon: <Error24 />,
  zIndex: Number(styles.zIndex),
};

export const confirm = (
  props: ModalFuncProps & { CustomModal?: typeof ModalBase } = {},
) => {
  const locale = localStorage.getItem(LANGUAGE_SELECT);
  const translations = locale ? getTranslationCache().get(locale) : null;

  const modalProps: ModalFuncProps = {
    ...props,
    okText: (
      <span data-cy={`modal.confirm.${props.okText || 'Ok'}`}>
        {props.okText ? props.okText : translations?.ok || 'Ok'}
      </span>
    ),
    cancelText: (
      <span data-cy={`modal.cancel.${props.cancelText || 'Cancel'}`}>
        {props.cancelText ? props.cancelText : translations?.cancel || 'Cancel'}
      </span>
    ),
  };

  const CustomModal = props.CustomModal || ModalBase;

  return CustomModal.confirm(
    merge({}, defaultModalProps, defaultMethodProps, modalProps),
  );
};

export const error = (props: ModalFuncProps = {}) =>
  ModalBase.error(merge({}, defaultModalProps, defaultErrorModalProps, props));
